import { restaurant } from "../data/menu";

export default function FloatingPhone() {
  return (
    <a
      href={`tel:${restaurant.phoneRaw}`}
      data-testid="floating-phone-cta"
      className="md:hidden fixed bottom-5 right-5 z-50 w-16 h-16 rounded-full bg-[#c23b22] text-white inline-flex items-center justify-center shadow-2xl pv-pulse"
      aria-label={`Appeler ${restaurant.name}`}
    >
      <i className="fa-solid fa-phone text-xl" aria-hidden="true"></i>
    </a>
  );
}
